import styled, { css } from 'styled-components';

export const Hr = styled.div`
    height: 1px;
    background-color: #ccc;
`;

export const BlockHeading = styled.h2`
    ${(props) => css(props.theme.typography.Headline)};
    color: ${(props) => props.color || props.theme.colors.Foreground};

    margin: 0 0 32px;

    ${(props) => props.theme.superQuery.all.and.maxWidth.mobileMax.css`
        font-size: 24px;
        line-height: 29px;
        margin: 0 0 8px;
    `}
`;
